import request from "./request";

const interactions = {
  service() {
    return {
      list(params) {
        return request.get("/interviews-api/interactions", params);
      },
      patch(id, data) {
        return request.patch(`/interviews-api/interactions/${id}`, data, null);
      },
      getRecordings(id) {
        return request.get(
          `/interviews-api/interactions/${id}/recordings`,
          null,
        );
      },
    };
  },
};

export default interactions;
